import { Subject } from 'rxjs';

export class ChampPersoPayload {
  guid: string;
  nom: string;
  obligatoire: boolean;
  typeChamp: number;
  choix: ChoixPayload[];
  valeurDefautStr: string | null;
  valeurDefautInt: number;
  valeurDefautBool: boolean | null;
  rubrique: string;
  actif: boolean;
  estLectureSeule: boolean;
  constructor() {
    this.choix = [];
  }
}

export class ChoixPayload {
  id: number;
  libelle: string;
  ordre: number;
}

export enum TypeChampPerso {
  Indetermine = 0,
  TexteLibre = 1,
  NombreEntier=2,
  ElementAuChoix=3,
  Date = 4,
  Booleen = 5
}

export class ItemChoix {
  constructor (public id: number, public libelle: string, public ordre: number) {}
}

export class ListeChoixBuilder {
  choix: ItemChoix[] = [];

  change$ = new Subject<ItemChoix[]>()

  resetWith(choix: ItemChoix[]) {
    this.choix = choix;
  }

  private reorderList() {
    this.choix.forEach((item, i) => item.id = item.ordre = i + 1)
    this.change$.next(this.choix)
  }

  addChoix(libelle: string) {
    this.choix.push(new ItemChoix(this.choix.length+1, libelle, this.choix.length+1))
    this.change$.next(this.choix)
  }

  removeChoix(idx: number) {
    this.choix.splice(idx, 1)
    this.reorderList()
  }

  swapOrder(idx1: number, idx2: number) {
    [this.choix[idx1], this.choix[idx2]] = [this.choix[idx2], this.choix[idx1]]
    this.reorderList()
  }
}

export interface IChampPersoViewModel {
  nom: string;
  guid: string;
  choix: ItemChoix[];
  rubrique: string;
  obligatoire: boolean;
  typeChamp: TypeChampPerso
  actif: boolean;
  estLectureSeule: boolean;
  valeurDefautStr: string;
  valeurDefautInt: number;
  valeurDefautBool: boolean;
}

export class ChampPerso {

  valeurDefautStr: string;
  valeurDefautInt: number;
  valeurDefautBool: boolean;

  rubrique: string;
  constructor(public nom: string, public obligatoire: boolean, public typeChamp: TypeChampPerso, valeurDefaut: string|boolean|number, public choix: ItemChoix[] = null, rubrique: string, public actif: boolean) {

    switch (typeChamp) {
      case TypeChampPerso.TexteLibre:
        this.valeurDefautStr = <string>valeurDefaut;
        break;
      case TypeChampPerso.ElementAuChoix:
        this.valeurDefautInt = <number>valeurDefaut;
        break;
      case TypeChampPerso.Booleen:
        this.valeurDefautBool = <boolean>valeurDefaut;
        break;
    }
    this.rubrique = rubrique;
  }

}
export enum ContextChampPerso{
  personne = 'personne',
  entreprise = 'entreprise',
  session = 'session',
  inscription = 'inscription',
  formation = 'formation',
  formateur = 'formateur',
}
